import { useEffect } from 'react';
import { useLanguageStore } from '@/context/LanguageStore';

export const useHtmlLang = () => {
	const lang = useLanguageStore(state => state.lang);

	useEffect(() => {
		if (lang) {
			// Extract the language code (e.g., 'en' from 'en-GB', 'sv' from 'sv-SE')
			const langCode = lang.split('-')[0];

			// Update the HTML element's lang attribute
			document.documentElement.lang = langCode;
		}
	}, [lang]);
};
